// extracted by mini-css-extract-plugin
export default {"button":"ContextMenuButton_button__D3KCq","text":"ContextMenuButton_text__oD0cc","image":"ContextMenuButton_image__x95kB"};